import React from "react";
import { LogoMain2 } from "@/app/icons/logo-main2";

function QuranNavSkelton() {
  return (
    <header className="sticky top-0 z-50 w-full border-b-2 border-border/40 backdrop-blur-sm">
      <div className="pr-6 pl-6 flex h-14 w-full items-center overflow-hidden">
        <div className="flex flex-row justify-between w-full align-middle">
          <div className=" rounded-md flex gap-4 mr-3">
            {[...Array(1)].map((_, index) => {
              return (
                <div
                  key={index}
                  className="w-5 h-5 rounded-full animate-pulse bg-muted"
                ></div>
              );
            })}
          </div>

          <div className="text-primary hidden md:flex items-center">
            <div className="font-extrabold text-foreground flex flex-row justify-center items-center">
              <div className="text-primary mr-2">
                {/* <svg viewBox="0 0 210 210" version="1.1" className="w-7 h-7">
                  <g>
                    <path
                      fill="currentColor"
                      d="M 5.7450681,6.4285177 C 5.6852021,6.4880221 5.6253357,10.355806 5.6253357,14.997146 v 8.41987 h 8.5309363 8.530936 l 0.05987,-7.527304 c 0.02994,-4.1058 0.05986,-7.943833 0.05986,-8.4793723 l 0.02994,-0.981822 -8.47107,-0.059504 c -4.6695647,-0.029753 -8.560869,0 -8.620736,0.059504 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 31.786874,6.4582698 c -0.0898,0.059505 -0.149666,8.4496212 -0.119732,18.5951152 0.02994,10.145495 0.02994,27.580276 0.02994,38.737345 l -0.02994,20.320742 h -4.340301 -4.340302 l -0.05986,-25.914153 -0.0898,-25.914153 -8.530936,0.02976 -8.5309355,0.02976 -0.089799,34.363773 -0.059866,34.363771 H 23.136205 46.364298 48.729015 V 53.913005 c 0,-25.943906 -0.02994,-47.2167178 -0.05987,-47.3059743 C 48.549416,6.3987654 31.966473,6.2500044 31.786874,6.4582698 Z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 57.888545,6.3690133 c -0.0898,0.089257 -0.179597,15.6198977 -0.179597,34.5125347 v 34.304269 h 8.620735 8.590803 V 49.390673 23.565777 l 12.961037,-0.08926 12.931097,-0.0595 v -8.47938 -8.4793722 l -21.102837,0.029753 c -11.614046,0 -21.222575,-0.059505 -21.342307,-0.1487609 -0.149665,-0.089257 -0.359198,-0.089257 -0.478931,0.029751 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 109.79256,14.759129 v 8.657887 h 8.53093 8.53094 V 14.937642 6.4582698 l -2.30485,-0.029752 c -1.28712,0 -5.11856,-0.059504 -8.53094,-0.148761 l -6.22608,-0.1785136 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 135.83436,6.2500044 c -0.0898,0.089257 -0.11974,3.9867926 -0.0598,8.6578866 l 0.0898,8.509125 h 8.50101 8.53094 V 14.937642 6.4582698 h -3.20285 c -1.79598,0 -5.59749,-0.089256 -8.47107,-0.1785132 -2.87358,-0.1190087 -5.29815,-0.1190087 -5.38796,-0.029753 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 161.87616,32.045149 c 0,14.162039 -0.11972,25.8844 -0.23946,26.062914 -0.11972,0.178514 -1.67625,0.267769 -4.46003,0.178514 l -4.28043,-0.11901 V 45.25512 32.34267 l -21.43212,-0.05951 c -11.79364,-0.05951 -21.49197,-0.02975 -21.55183,0.02976 -0.0599,0.0595 -0.11973,9.758717 -0.11973,21.51083 v 21.362065 l 12.96103,0.0595 12.93111,0.08926 v 4.314066 4.314067 h -17.36121 -17.36121 l -0.0898,-25.824896 -0.0599,-25.795145 h -8.231592 c -4.519899,0 -8.321405,-0.02975 -8.441138,-0.08926 -0.149665,-0.02976 -0.29933,11.573599 -0.38913,25.824895 l -0.149665,25.884401 -12.931104,0.08926 -12.961037,0.05951 v 8.479373 8.479384 H 105.30255 152.8962 V 88.128018 75.185817 h 13.0209 12.99098 V 40.822044 6.488022 L 170.40707,6.398765 161.87613,6.309508 Z M 135.6847,53.764243 v 4.314067 h -4.3403 -4.3403 l -0.0898,-4.403323 -0.0898,-4.403325 4.4301,0.08926 4.43011,0.08926 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 187.88804,6.4582698 c -0.0299,0.089257 -0.0299,0.2380174 0,0.3570263 0,0.1190088 0,6.6644889 0,14.5785699 0,7.914082 0,14.757084 0.0299,15.26287 0.0299,0.476036 0.0299,1.75538 0.0299,2.826458 0,1.07108 -0.0599,11.514096 -0.0898,23.206704 l -0.0898,21.272812 -12.9311,0.08926 -12.96104,0.05951 v 8.479372 8.479368 h 21.55184 21.55185 V 53.764243 6.488022 l -8.53095,-0.089257 c -4.69949,-0.059504 -8.56087,-0.029752 -8.56087,0.059505 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 110.00209,109.87687 c -0.11974,0.11899 -0.20953,15.67939 -0.20953,34.54228 l 0.0599,34.30426 12.90118,0.0594 12.9311,0.0893 0.0898,4.37357 0.0898,4.40333 H 118.47319 101.11198 V 161.6159 135.58273 h -8.530925 -8.530937 l -0.05987,25.94389 -0.0898,25.97367 -12.931104,0.0893 -12.961037,0.0594 v 8.47938 8.47938 h 5.507693 61.09348 54.32859 v -13.23979 -50.63822 -31.12079 l -1.82592,0.20826 c -1.01772,0.0894 -4.8791,0.17852 -8.53094,0.17852 h -6.70502 v 37.458 l -0.62858,40.1357 h -5.20837 l -2.99331,-0.0893 -0.0898,-12.88269 -0.0598,-12.85296 H 140.0251 127.15387 v -17.40502 -17.40503 h 4.34031 4.34029 v 22.93894 2.94547 h 8.53094 8.53094 v -9.46119 -22.04637 -11.33559 H 132.8711 c -10.98545,0 -20.59399,-0.0892 -21.31239,-0.17852 -0.71838,-0.0893 -1.43678,-0.0594 -1.55651,0.0595 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 140.74339,141.97947 c -0.2694,0.6248 0.0898,1.33885 0.6286,1.33885 0.62859,0 0.89799,-0.80331 0.44899,-1.33885 -0.47892,-0.5653 -0.86806,-0.5653 -1.07759,0 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 6.2239979,157.30184 v 47.30597 H 27.775837 49.327676 v -8.47937 -8.47937 H 36.306774 23.285871 v -1.21985 -1.19009 l 0.05986,-20.05295 0.0898,-12.1984 25.802341,-0.0894 25.832275,-0.0595 0.05987,-12.8827 0.0898,-12.85294 12.961037,-0.0893 12.931096,-0.0595 v -8.47931 -8.47936 H 79.560118 58.008278 v 12.94219 12.94221 h -4.340301 -4.340301 v -12.9421 -12.94221 H 41.395402 18.197242 6.2239979 Z m 25.7424751,-25.8844 v 4.46283 h -4.340301 -4.340301 v -4.46283 -4.46282 h 4.340301 4.340301 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 187.91798,137.01085 v 51.56053 16.03643 h 8.53093 8.53094 v -47.30597 -47.30598 h -8.53094 -8.53093 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 31.966473,166.94156 -0.119732,11.78185 h 8.740467 8.740468 v -7.6463 -7.64633 c 0.109442,0.0687 -0.0563,-1.63579 -0.0563,-1.63579 l -12.36593,-0.0304 h -4.938964 z"
                    ></path>
                    <path
                      fill="currentColor"
                      d="m 58.008278,170.24405 v 8.47936 h 8.530937 8.530936 v -8.47936 -8.47939 h -8.530936 -8.530937 z"
                    ></path>
                  </g>
                </svg> */}
                <LogoMain2 className="w-10 h-10 bg-primary/80 p-1 rounded-md text-white" />
              </div>
              <div>QuranExcel</div>
            </div>
          </div>
          <div className="flex flex-row items-center">
            <div className=" rounded-md flex gap-4 mr-3">
              {[...Array(3)].map((_, index) => {
                return (
                  <div
                    key={index}
                    className="w-5 h-5 rounded-full animate-pulse bg-muted"
                  ></div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <h2
        id="radix-:r8t:"
        className="text-lg font-semibold text-foreground"
      ></h2>
    </header>
  );
}

export default QuranNavSkelton;
